import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FieldSet, OfbizField, OfbizForm, OfbizFormField, OfbizFormsService, FormUtilityService } from '@urbannex/ofbiz-forms';
import { take } from 'rxjs/operators';
import { CustomContainerInterFace } from '../../custom-container/custom-container-interface';
import { SelectedValue } from '../../shared/model';

@Component({
  selector: 'ubs-product-edit-container',
  templateUrl: './product-edit-container.component.html',
  styleUrls: ['./product-edit-container.component.scss']
})
export class ProductEditContainerComponent implements OnInit, CustomContainerInterFace {

  data: any;
  selectedValue: any;
  ofbizForm: OfbizForm;
  fieldSets: FieldSet[];
  editProductForm: FormGroup;
  /**
   * @description
   * Raw Form fields with or without values passed in from the form object in the initializing data.
   *
   */
  fields: OfbizField[];
  /**
   * @description
   * Form fields defined as OfbizFormField types
   */
  formFields: OfbizFormField<any>[];
  hiddenFields: OfbizFormField<any>[];
  shownFields: OfbizFormField<any>[];
  /**
   * @description
   * Form to hold values used in getting the edit value from the backend
   */
  tempForm = this.fb.group({});
  /**
   * @description
   * Boolean to check whether all form controls have been loaded
   */
  isLoaded: boolean = false;
  childForms: { [key: string]: FormGroup } = {}; // Add this

  constructor(
    private fb: FormBuilder,
    private ofbizFormsService: OfbizFormsService,
    private formUtilityService: FormUtilityService
  ) { }

  ngOnInit(): void {
    console.log({ CustomData: this.data })
    this.fields = this.data.form.fields ? this.data.form.fields : [];
    this.fieldSets = this.data.form.fieldSets ? this.data.form.fieldSets : [];
    this.ofbizForm = this.data.form;
    setTimeout(() => {                           // <<<---using ()=> syntax
      this.createForm(this.ofbizForm, this.fieldSets);
    }, 300);



  }

  createForm(ofbizForm: OfbizForm, fieldSets: FieldSet[]): void {
    // this.editProductForm = this.fb.group(this.getFormArrays(fieldSets));
    this.editProductForm = this.fb.group(this.getFormGroups(fieldSets));

    this.ofbizFormsService.getFormFields(ofbizForm["fields"])
      .subscribe((formFields: OfbizFormField<any>[]) => {
        this.formFields = formFields;
        console.log({ AddingControlsFields: this.formFields })
        if (formFields.length > 0) {
          /* if(this.isLookup){
            this.addOptionalFields(this.formFields);
          } */
          this.hiddenFields = this.formFields.filter(field => field.controlType == 'hidden' || field.controlType == 'HIDDEN');
          this.shownFields = this.formFields.filter(field => field.controlType != 'hidden' && field.controlType != 'HIDDEN');
          Object.keys(this.editProductForm.controls).forEach(key => {
            console.log({ AddingControlsFor: key })
            const fieldSetFormFields: OfbizFormField<any>[] = this.getFieldSetFormFields(fieldSets, key)
            if (fieldSetFormFields != undefined) {
              const fieldSetGroup = this.editProductForm.get(key) as FormGroup;
              // console.log(fieldSetFormFields)
              fieldSetFormFields.forEach(fieldSetFormField => {
                console.log(fieldSetFormField)
                if (fieldSetFormField.name) {
                  console.log({ AddingControls: fieldSetFormField.name, Value: fieldSetFormField.value })
                  // this.editProductForm.controls[key]["controls"][fieldSetFormField.name] = new FormControl(fieldSetFormField.value || '')
                  // Add control to the fieldset FormGroup
                  fieldSetGroup.addControl(
                    fieldSetFormField.name,
                    new FormControl(fieldSetFormField.value || '')
                  );
                }
              })
              this.childForms[key] = fieldSetGroup; // Store reference to child FormGroup
            }


          })
          this.isLoaded = true;
          console.log({ Controls: this.editProductForm.controls });
        }
      })
  }

  // Changed to create FormGroups instead of FormArrays
  /**
   * Create FormGroups for each fieldSet to allow for nested form structure, which is more suitable for the fieldSet and fields relationship. Each FormGroup will represent a fieldSet and contain controls for its fields.
   * @param fieldSets
   * @returns
   */
  getFormGroups(fieldSets: FieldSet[]) {
    const group = {};
    fieldSets.forEach(fieldSet => {
      group[fieldSet.fieldSetName] = this.fb.group({}); // Create empty FormGroup
    });
    return group;
  }
  getFormArrays(fieldSets: FieldSet[]) {
    const group = {};
    fieldSets.forEach(fieldSet => {
      group[fieldSet.fieldSetName] = new FormArray([]);
    })
    return group
  }

  getFieldSetFormFields(fieldSets: FieldSet[], key: string): OfbizFormField<any>[] {
    console.log({ FormFields: this.formFields });
    const fieldSetFormFields = [];
    const fieldSet: FieldSet = fieldSets.find(fieldSet => fieldSet.fieldSetName == key);
    if (fieldSet) {
      fieldSet.fields.forEach(fieldSetField => {
        const selectedFormField = this.formFields.find(formField => formField.name == fieldSetField);
        if (selectedFormField != undefined) {
          fieldSetFormFields.push(selectedFormField)
        }

      });
    }

    return fieldSetFormFields
  }

  // Add a method to handle form submission and log the complete form value
  onSubmit(): void {
    console.log('Complete form value on submit:', this.editProductForm.value);
    // Check if form is nested
    if (this.formUtilityService.isNestedFormValue(this.editProductForm.value)) {
      console.log('Form has nested structure');

      // Get all field names
      const fieldNames = this.formUtilityService.getFormFieldNames(this.editProductForm.value);
      console.log('All field names:', fieldNames);

      // Create FormData with custom options
      // Use dot notation flattening to match backend expectations like 'Classification.productId'
      /* const formData = this.formUtilityService.createFormDataFromValue(this.editProductForm.value, {
        separator: '.', // Use dot separator (this is the default)
        includeNullValues: false
      }); */
      /* const formData = this.formUtilityService.createFormDataFromValue(
        this.editProductForm.value,
        {
          separator: '_',
          prefix: 'form',
          includeNullValues: false
        }
      ); */
      const formData = this.formUtilityService.createFormDataFromValue(this.editProductForm.value, {
        isFieldsetForm: true,        // Recognize fieldset structure
        preserveFieldsetNames: false, // Keep 'Classification.' prefix
        separator: '.',               // Use dot separator (default)
        useOriginalFieldNamesOnly: true // Use original field names only
      });
      formData.forEach((value, key) => {
        console.log(`${key}:`, value);
      });
      /* this.httpService.post('/api/submit', formData).subscribe(response => {
        console.log('Submitted successfully:', response);
      }); */
    }
    console.log('Form valid:', this.editProductForm.valid);
  }

}
